import React, { useState, useRef } from "react";
import Config from "../../Config";

import back from "../../back.png";
import PlTitle from "../../elements/PlTitle";
import BkTextEditor from "../../BkTextEditor/BkTextEditor";
import InputCombo from "../../helpers/InputCombo";
import InputText from "../../helpers/InputText";


function ContractPDF(props)
{
 
    const [nazwaSzablonu, setNazwaSzablonu] = useState("");
 
    const [row, setRow] = useState( null);
    const [txtPDF, setTxtPDF] = useState(null);

    const [p_szablon_id, setPSzablonId] = useState(-1);
    const [templates, setTemplates] = useState(null);


 

    const [detTemplate, setDetTemplate] = useState(null);


    const [regList, setRegList] = useState([
          { toRep:'@numer_umowy', type:'def', title:'numer umowy' },
          { toRep:'@data_zawarcia', type:'def', title:'data zawarcia umowy' },
          { toRep:'@miejsce_zawarcia_umowy', type:'def', title:'miejsce zawarcia umowy' },
          { toRep:'@data_od', type:'def', title:'data początkowa umowy' },
          { toRep:'@data_do', type:'def', title:'data zakończenia umowy' },
          { toRep:'@nazwa_przedszkola', type:'def', title:'nazwa placówki bez danych adresowych' },
          { toRep:'@imie_nazwisko_rodzica_1', type:'def', title:'imię i nazwisko pierwszego z rodziców' },
          { toRep:'@imie_nazwisko_rodzica_2', type:'def', title:'imię i nazwisko drugiego z rodziców' },
          { toRep:'@adres_rodzica_1', type:'def', title:'adres rodzica pierwszego' },
          { toRep:'@adres_rodzica_2', type:'def', title:'adres rodzica drugiego' },
          { toRep:'@email_rodzica_1', type:'def', title:'adres e-mail pierwszego rodzica' },
          { toRep:'@email_rodzica_2', type:'def', title:'adres e-mail drugiego rodzica' },
          { toRep:'@telefon_rodzica_1', type:'def', title:'nr telefonu pierwszego rodzica' },
          { toRep:'@telefon_rodzica_2', type:'def', title:'nr telefonu drugiego rodzica' },
          { toRep:'@numer_dowodu_rodzic_1', type:'def', title:'nr dowodu pierwszego rodzica' },
          { toRep:'@numer_dowodu_rodzic_2', type:'def', title:'nr dowodu drugiego rodzica' },
          { toRep:'@numer_pesel_rodzic_1', type:'def', title:'nr pesel pierwszego rodzica' },
          { toRep:'@numer_pesel_rodzic_2', type:'def', title:'nr pesel drugiego rodzica' },
          { toRep:'@imie_nazwisko_dziecka', type:'def', title:'imię i nazwisko dziecka' },
          { toRep:'@pesel_dziecka', type:'def', title:'pesel dziecka' },
          { toRep:'@data_urodzenia_dziecka', type:'def', title:'data urodzenia dziecka' },
          { toRep:'@miejsce_zamieszkania_dziecka', type:'def', title:'miesjce zamieszkania dziecka' },
          { toRep:'@miejsce_urodzenia_dziecka', type:'def', title:'miesjce urodzenia dziecka' },
    ]);

    const [stawki, setStawki]     = useState(null);

    
        const onBack = () => {


          
            props.mainView.showDialog( "Zapisać zmiany", "Chcesz zapisać zmiany w dokumencie PDF?" , "yesno" ,  (resp) => {

                if(resp == 'yes')
                {
                    saveContent(true);
                }else 
                {
                    props.onBack();
                }

            } );  

        }


        const getUmowa = () => {
        
    
            props.mainView.setProgress(-2);

            var req = {
                id: props.id
            };

            fetch( Config.url + '/rest_v1_calc,contract_det', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
            })         
            .then(res => res.json() )
            .then(res => { 

                        props.mainView.setProgress(-1);        
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {
                            props.mainView.setProgress(-1);  
                            if(res.status == 'OK') 
                            {
                                                    
                                //---------------------------------------------------
                                //---------------------------------------------------
                                var stawki = [];
                                var zajecia = [];

                                res.result.stawki.forEach( (item) => {


                                    stawki.push(
                                        {
                                            id: item.id,
        
                                            p_typy_oplat:  item.p_typy_oplat, 
                                            nazwa_stawki:  item.nazwa_stawki, 
                                            kwota_netto:  item.kwota_netto, 
                                            naliczanie_dzienne:  item.naliczanie_dzienne, 
                                            naliczanie_miesieczne:  item.naliczanie_miesieczne, 
                                            naliczanie_godzinowe:  item.naliczanie_godzinowe, 
                                            naliczanie_nadgodzin:  item.naliczanie_nadgodzin, 
                                            naliczanie_jednorazowe:  item.naliczanie_jednorazowe, 
                                            rozliczaj_normalnie:  item.rozliczaj_normalnie, 
                                            naliczanie_wlasne:  item.naliczanie_wlasne, 
                                            naliczanie_wlasne_symbol:  item.naliczanie_wlasne_symbol, 
        
                                            p_subkonta_id: item.p_subkonta_id, 
                                            nazwa_konta:   item.nazwa_konta, 
                                            numer_konta:   item.numer_konta,                                         
        
                                            data_od: item.data_od,
                                            data_do: item.data_do,

                                            created_at: item.created_at,
                                            updated_at: item.updated_at,
                                        }
                                    );

                                } ) 

                                res.result.zajecia.forEach (  (item) => {

                                    zajecia.push( {
                                        id: item.id,

                                        p_typy_oplat:  item.p_typy_oplat, 
                                        nazwa_zajecia:  item.nazwa_zajecia, 
                                        kwota: item.kwota,        

                                        p_subkonta_id: item.p_subkonta_id, 
                                        nazwa_konta:   item.nazwa_konta, 
                                        numer_konta:   item.numer_konta, 


                                    });

                                } );

                            

                                var defX = {


                                    id: res.result.id,
                                    numer_umowy2: res.result.numer_umowy,  
                                    num_na_fakturze: '0',
                                    
                                    stan_umowy: res.result.stan_umowy,
                            
                            
                                    data_zawarcia: res.result.data_zawarcia,                                
                                    data_od: res.result.data_od,                                
                                    data_do: res.result.data_do,
                            
                                    czas_pobytu_od: res.result.czas_pobytu_od,
                                    czas_pobytu_do: res.result.czas_pobytu_do,
                            
                            
                                    godziny_bezplatene_1: res.result.godziny_bezplatene_1,
                                    godziny_bezplatene_1_od: res.result.godziny_bezplatene_1_od,
                                    godziny_bezplatene_1_do: res.result.godziny_bezplatene_1_do,
                                    sposob_naliczania_godzin: res.result.sposob_naliczania_godzin,
                            
                                    godziny_bezplatene_1_pn_od: res.result.godziny_bezplatene_1_pn_od,
                                    godziny_bezplatene_1_pn_do: res.result.godziny_bezplatene_1_pn_do,
                                    godziny_bezplatene_1_wt_od: res.result.godziny_bezplatene_1_wt_od,
                                    godziny_bezplatene_1_wt_do: res.result.godziny_bezplatene_1_wt_do,
                                    godziny_bezplatene_1_sr_od: res.result.godziny_bezplatene_1_sr_od,
                                    godziny_bezplatene_1_sr_do: res.result.godziny_bezplatene_1_sr_do,        
                                    godziny_bezplatene_1_cz_od: res.result.godziny_bezplatene_1_cz_od,
                                    godziny_bezplatene_1_cz_do: res.result.godziny_bezplatene_1_cz_do,        
                                    godziny_bezplatene_1_pt_od: res.result.godziny_bezplatene_1_pt_od,
                                    godziny_bezplatene_1_pt_do: res.result.godziny_bezplatene_1_pt_do,     

                                    gotowy_tekst: res.result.gotowy_tekst,     
                                    p_szablon_id: res.result.p_szablon_id,     
                                    
                                    e_wezwanie_e_mail: '1',
                                    e_wezwanie_sms: '1',
                            
                            
                            
                                    stan_umowy: res.result.stan_umowy, //aktywna..
                                    p_dziecko_id: -1,
                                    imie_dziecka: res.result.imie,
                                    nazwisko_dziecka: res.result.nazwisko,
                            
                            
                                    okres_do_wystawienia: res.result.okres_do_wystawienia,                                
                                    e_faktura: '1',
                                    e_sms: '1',
                                    odsetki_ustawowe: '0',
                            
                                    roz_na_koniec_m:   res.result.roz_na_koniec_m , 
                            
                            
                                    newStawka: '_x_',
                                    stawki: stawki,
                            
                                    newZajecia: '_x_',
                                    zajecia: zajecia, 
                            
                                };
                                            
                                setRow(defX);

                                setTxtPDF(defX.gotowy_tekst);
                                setPSzablonId(defX.p_szablon_id);
                                //---------------------------------------------------
                                //---------------------------------------------------


                            }
                            if(res.status == 'ERROR') {
                                props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                            }

                        }
            } )
            .catch(err => {          
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                        props.mainView.setProgress(-1);
            });
                    

            return false;
        }


        const getTemplates = () => {
        
    
            props.mainView.setProgress(-2);

            var req = {
                id: props.id
            };

            fetch( Config.url + '/rest_v1_calc,contract_template', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
            })         
            .then(res => res.json() )
            .then(res => { 

                        props.mainView.setProgress(-1);        
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {
                            props.mainView.setProgress(-1);  
                            if(res.status == 'OK') 
                            {
                                                    
                               setTemplates(res.result);


                            }
                            if(res.status == 'ERROR') {
                                props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                            }

                        }
            } )
            .catch(err => {          
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                        props.mainView.setProgress(-1);
            });
                    

            return false;
        }


        const getDetTemplate = () => {
        
    
            props.mainView.setProgress(-2);

            var req = {
                id: props.id
            };

            fetch( Config.url + '/rest_v1_calc,details_for_template', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
            })         
            .then(res => res.json() )
            .then(res => { 

                        props.mainView.setProgress(-1);        
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {
                            props.mainView.setProgress(-1);  
                            if(res.status == 'OK') 
                            {                                                    
                               setDetTemplate(res.result);
                            }
                            if(res.status == 'ERROR') {
                                props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                            }

                        }
            } )
            .catch(err => {          
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                        props.mainView.setProgress(-1);
            });
                    

            return false;
        }


          const getStawki = () => {
       
 
        props.mainView.setProgress(-2);

        var req = {
        
        };

        fetch( Config.url + '/rest_v1_calc,stawki', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') 
                        {
                            setStawki(res.result);   

                            var jsP = JSON.parse( JSON.stringify(regList) );

                            for(var m=0; m < res.result.length; m++)
                            {
                                jsP.push(
                                      { toRep: '@st_kwota_'+res.result[m].id , type:'st', title:'Kwota stawki (' + res.result[m].nazwa + ', ' + res.result[m].kwota_netto + ')' }
                                );
                                jsP.push(
                                      { toRep: '@st_nazwa_'+res.result[m].id , type:'st', title:'Nazwa stawki (' + res.result[m].nazwa + ', ' + res.result[m].kwota_netto + ')' }
                                );
                            }

                            setRegList(jsP);

                        }
                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



        const getPDF = () => {
       
       
            var txtPre = preperText(txtPDF, false);
            
            txtPre = "<html> <body style=\"font-family: serif; font-size: 11px;\"> " + txtPre + " </body></html> ";

            
            props.mainView.setProgress(-2);
    
            var req = {
                    html: txtPre,
                    orientation: "portrait",
                    title: "Umowa " + row.numer_umowy
            };
    
            fetch(  Config.master + '/rest_v1,html_to_pdf', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                              
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
             })
             .then(res => res.json() )
             .then(res => { 
    
                        props.mainView.setProgress(-1);        
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {
                         // var decodedString = atob(res.result.b64);           
                        //  setStream(res.result.b64);   
                        
                            let pdfWindow = window.open("");
                            pdfWindow.document.write("<html<head><title>Umowa</title><style>body{margin: 0px;}</style></head>");
                            pdfWindow.document.write("<body><embed width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(res.result.b64)+"#toolbar=0&navpanes=0&scrollbar=0'></embed></body></html>");
                            pdfWindow.document.close();

                        }
             } )     
             .catch(err => {          
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                        props.mainView.setProgress(-1);
             });
                       
    
             return false;
        }




       //zmiana szablonu.. 
       const valChangeListener2 = (filedName, val, correct, msg) => { 

                if(val == -1)
                {
                    setPSzablonId( val );
                    setNazwaSzablonu("");
                    setTxtPDF("..." );
                    return;
                }
                
                for(var w=0; w< templates.length; w++)
                    {
                        if( templates[w].id == val)
                        {
                           setPSzablonId( val );
                           setNazwaSzablonu(templates[w].nazwa);
                           setTxtPDF(templates[w].tresc   );
                        }                        
                    }
       }

       //zmiana w tresci..
       const valChangeListener = (filedName, val, correct, msg) => {         
               setTxtPDF(val);
       }

       //nazwa szablonu
       const valChangeListenerS = (filedName, val, correct, msg) => {         
           setNazwaSzablonu(val);
        }


       const preperText = (htmlRAW, showColor) => {

            var ready = htmlRAW;

            var start = "<span class=\"editor_color\">";
            var end   = "</span>";


            if(showColor == false)
            {
                start = "";
                end = "";
            }


            ready = ready.replaceAll("@numer_umowy",  start + row.numer_umowy2 + end );            
            ready = ready.replaceAll("@data_zawarcia",start + row.data_zawarcia + end );            
            ready = ready.replaceAll("@miejsce_zawarcia_umowy", start +detTemplate.przedszkole.miasto + end );            

            ready = ready.replaceAll("@data_od", start +row.data_od + end );                        
            ready = ready.replaceAll("@data_do",start +row.data_do + end );            

            ready = ready.replaceAll("@nazwa_przedszkola", start +detTemplate.przedszkole.nazwa + end );            

            ready = ready.replaceAll("@imie_nazwisko_rodzica_1", start +detTemplate.r1.imie + " "  + detTemplate.r1.nazwisko + end  );            
            ready = ready.replaceAll("@imie_nazwisko_rodzica_2",start + detTemplate.r2.imie + " "  + detTemplate.r2.nazwisko   + end  );            

            ready = ready.replaceAll("@adres_rodzica_1",start +start + detTemplate.r1.ulica + " "  + detTemplate.r1.nr_domu + " / " + detTemplate.r1.nr_mieszkania + " " + detTemplate.r1.kod_pocztowy + " " + detTemplate.r1.miasto  + end );            
            ready = ready.replaceAll("@adres_rodzica_2", detTemplate.r2.ulica + " "  + detTemplate.r2.nr_domu + " / " + detTemplate.r2.nr_mieszkania + " " + detTemplate.r2.kod_pocztowy + " " + detTemplate.r2.miasto  + end );            


            ready = ready.replaceAll("@email_rodzica_1", start +detTemplate.r1.email + end ); 
            ready = ready.replaceAll("@email_rodzica_2",start + detTemplate.r2.email + end ); 

            ready = ready.replaceAll("@telefon_rodzica_1", start +detTemplate.r1.telefon + end ); 
            ready = ready.replaceAll("@telefon_rodzica_2", start +detTemplate.r2.telefon + end ); 

            ready = ready.replaceAll("@numer_dowodu_rodzic_1", start +detTemplate.r1.nr_dowodu + end ); 
            ready = ready.replaceAll("@numer_dowodu_rodzic_2", start +detTemplate.r2.nr_dowodu + end ); 

            ready = ready.replaceAll("@numer_pesel_rodzic_1",start + detTemplate.r1.pesel + end ); 
            ready = ready.replaceAll("@numer_pesel_rodzic_2", start +detTemplate.r2.pesel + end ); 

            ready = ready.replaceAll("@imie_nazwisko_dziecka", start +detTemplate.imie + " " + detTemplate.nazwisko  + end  ); 
            ready = ready.replaceAll("@pesel_dziecka", start + detTemplate.pesel  + end  ); 
            ready = ready.replaceAll("@data_urodzenia_dziecka", start +detTemplate.data_urodzenia + end   ); 
            ready = ready.replaceAll("@miejsce_urodzenia_dziecka", start +detTemplate.miejsce_urodzenia  + end  ); 

            ready = ready.replaceAll("@miejsce_zamieszkania_dziecka", start +detTemplate.ulica + " " + detTemplate.nr_domu + "/" + detTemplate.nr_mieszkania + " " + detTemplate.kod_pocztowy + " " + detTemplate.miasto  + end  ); 
            ready = ready.replaceAll("@miejsce_zameldowania_dziecka", start + detTemplate.kr_ulica + " " + detTemplate.kr_nr_domu + "/" + detTemplate.kr_nr_mieszkania + " " + detTemplate.kr_kod_pocztowy + " " + detTemplate.kr_miasto  + end  ); 


            for(var m=0; m < regList.length; m++)
            {
                if(regList[m].type == 'def') continue; //obsłużone wyżej..

                var params = regList[m].toRep.split("_");
               // console.log("params", params);

                var idStawki = parseInt(params[2]);
                var indFinded = -1;

                for(var s=0; s< stawki.length; s++)
                {
                    if(stawki[s].id == idStawki) {   indFinded = s; break; }
                }

                if(indFinded == -1) continue;

                if(params[1] == 'kwota')
                {
                    ready = ready.replace( regList[m].toRep , start + stawki[indFinded]['kwota_netto']  + end  ); 
                }

                if(params[1] == 'nazwa')
                {
                    ready = ready.replace( regList[m].toRep , start + stawki[indFinded]['nazwa']  + end  ); 
                }



            }




            return ready;
       }




       
       const saveTemplate = () => {

     
            props.mainView.setProgress(-2);

            var req = {
                p_szablon_id: p_szablon_id,
                nazwa: nazwaSzablonu,
                txt: txtPDF,
            };

            fetch( Config.url + '/rest_v1_calc,save_template', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
            })         
            .then(res => res.json() )
            .then(res => { 

                        props.mainView.setProgress(-1);        
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {
                            props.mainView.setProgress(-1);  
                            if(res.status == 'OK') 
                            {
                                getTemplates();
                                props.mainView.showDialog( "Sukces", "Szablon został zapisany!" , "ok" ,  (resP)=>{

                                      setPSzablonId( res.result );
                                      
                                } );                                                                                    
                            }
                           

                        }
            } )
            .catch(err => {          
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                        props.mainView.setProgress(-1);
            });
                    

            return false;
        }



      const saveContent = (exit) => {


            var txtReady = preperText(txtPDF);
     
            props.mainView.setProgress(-2);

            var req = {
                p_umowa_id: props.id,
                p_szablon_id: p_szablon_id,      
                txt: txtReady,
            };

            fetch( Config.url + '/rest_v1_calc,save_contract_txt', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
            })         
            .then(res => res.json() )
            .then(res => { 

                        props.mainView.setProgress(-1);        
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {
                            props.mainView.setProgress(-1);  
                            if(res.status == 'OK') 
                            {
                             
                                props.mainView.showDialog( "Sukces", "Treść umowy została zapisana" , "ok" ,  (resP)=>{

                                    if(exit != null && exit)
                                    {
                                        props.onBack();
                                    }
                                      
                                } );                                                                                    
                            }
                           

                        }
            } )
            .catch(err => {          
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                        props.mainView.setProgress(-1);
            });
                    

            return false;
        }



        if(row == null)
            {        
                setRow([]);
                getUmowa();            
                return <span>...</span>
            }

        if(stawki == null)
            {        
                setStawki([]);
                getStawki();            
                return <span>...</span>
            }            

        if(templates == null)
        {
            setTemplates([]);
            getTemplates();
            return <span>...</span>
        }

        if(detTemplate == null)
        {
            getDetTemplate();
            return <span>...</span>
        }


        console.log("txtPDF: ", txtPDF, "||", row.gotowy_tekst);

        if(txtPDF == null)
        {
            return <span>....</span>
        }

        if(row.gotowy_tekst == null)
            {
                return <span>....</span>
            }
      


        var itemsTemplate = new Array();

        itemsTemplate.push({
            v: -1,
            title: "Szablon domyślny",
        });

        for(var w=0; w< templates.length; w++)
        {
            itemsTemplate.push({
                v: templates[w].id,
                title: templates[w].nazwa,
            });
        }


        

        var readyHTML = "";
        if(txtPDF != null ) readyHTML =  preperText(txtPDF, true);


        return  <div className="view_content">
                            <img src={back} onClick={onBack} className="back_img" title="wstecz"/>

                           
                         

                                  
                            <div className="h_separate">Edytor umowy</div>
                            <br/>                                                      
                         
                      
                            <div className="form_tab">

                                         <div className="form_control">
                                                                <div className="fieldName">Szablon*    </div>
                                                                <InputCombo   items={itemsTemplate}  value={row.p_szablon} err={null}  valChange={valChangeListener2} goNext={null} name="p_szablon_id" placeholder={""} className=' ' req='1'   />
                                        </div>

                            </div>

                            <div className="form_tab_title">Wyrażenia regularne, które mogą być użyte w treści umowy</div>
                            <div className="form_tab">
                                 <div className="scroll100">
                                        <ul>
                                            {
                                                regList.map( (r, inx) => {
                                                    return <li>{r.toRep}  - &nbsp;   {r.title}</li>
                                                } )
                                            }
                                      
                                        </ul>
                                 </div>
                            </div>


                     
                            <div className="form_tab">

                                    <div className="form_control">                                                                                                                 
                                        <BkTextEditor  name="tresc" valChange={valChangeListener}  value={txtPDF} mini="1"  req='1' refresh={p_szablon_id}  /> 
                                    </div>

                                    
                                    <div className="form_control">
                                        <div className="fieldName">Zapisz szablon: </div>
                                        <InputText   userData={props.userData} value={nazwaSzablonu} err={null}  valChange={valChangeListenerS} goNext={null} name="nazwaSzablonu" placeholder={"Nazwa szablonu:"} className=' ' req='1'   />
                                    </div>    

                                    {
                                        p_szablon_id != -1 &&                                        
                                        <div className="form_control">
                                            <div className="btn" onClick={saveTemplate}>zaktualizuj szablon</div>
                                        </div>
                                    }

                                    {
                                        p_szablon_id == -1 &&
                                        <div className="form_control">
                                            <div className="btn" onClick={saveTemplate}>zapisz nowy szablon</div>
                                        </div>
                                    }
                                  
                                    

                            </div>

                            <br/>         





                            <div className="form_control">
                                                                              
                                            <div className="btn" onClick={saveContent}>zapisz treść umowy</div>
                                            &nbsp; 
                                            <div className="btn" onClick={getPDF}>pobierz .PDF</div>
                            </div>
                            <br/><br/>
                            <div>
                                    <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                            </div>
                            
                            <br/>                                  
                            <div className="h_separate">Podgląd dokumentu</div>
                            <br/>

                            <div className="form_tab">
                                 <div className="pdf_review" dangerouslySetInnerHTML={{__html: readyHTML}}></div>
                            </div>                                                             
                           
                          
                             <br/>
                             <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                             <br/>   
                         

        </div> 

}


export default ContractPDF;